export interface IDemandProductPrice {
    unitPrice: number;
    currency: string;
    taxRate: number;
    taxAmount: number;
    linePrice: number;
}

export class DemandProductPrice implements IDemandProductPrice {
    currency = 'EUR';
    unitPrice = 0;
    taxRate = 19;
    taxAmount = 0;
    linePrice = 0;

    public static fromDto(dto: IDemandProductPrice): DemandProductPrice {
        const price = new DemandProductPrice();
        Object.assign(price, dto);

        return price;
    }
}
